import { api, getList } from "./api";
import type { Releve } from "../types/releve";

export async function getReleves(): Promise<Releve[]> {
  return getList<Releve>("/releves/");
}

export async function getReleve(id: string): Promise<Releve> {
  const res = await api.get(`/releves/${id}/`);
  return res.data;
}

export async function createReleve(payload: Partial<Releve>): Promise<Releve> {
  const res = await api.post("/releves/", payload);
  return res.data;
}

export async function updateReleve(id: string, payload: Partial<Releve>): Promise<Releve> {
  const res = await api.put(`/releves/${id}/`, payload);
  return res.data;
}

export async function deleteReleve(id: string): Promise<void> {
  await api.delete(`/releves/${id}/`);
}
